import { render } from "./vsaleuseredit.vue?vue&type=template&id=20f55b9e&scoped=true"
import script from "./vsaleuseredit.vue?vue&type=script&lang=js"
export * from "./vsaleuseredit.vue?vue&type=script&lang=js"

import "./vsaleuseredit.vue?vue&type=style&index=0&id=20f55b9e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f55b9e"]])

export default __exports__